<template>
    <ValidationObserver ref="modalValidation" tag="div" v-slot="{ invalid }">
        <b-modal ref="bv-modal" class="in" :cancel-title="cancelTitle" :ok-title="okTitle" :ok-only="okOnly" @shown="afterOpen" @ok="handleOK" :ok-disabled="!allowOK || invalid" :cancel-disabled="!allowClose" :no-close-on-backdrop="!allowClose" :no-close-on-esc="!allowClose">
            <template v-slot:modal-header>
                <slot name="header" />
            </template>
                <slot v-if="!isLoading && !inProgress"></slot>
                <div v-if="isLoading || inProgress || isError" style="text-align: center">
                    <i v-if="isLoading || inProgress" class="fas fa-spinner fa-spin fa-4x" />
                    <div v-if="isError" class="alert alert-danger" role="alert">{{$t('error_title')}} {{errorMessage}}</div>
                </div>
        </b-modal>
    </ValidationObserver>
</template>

<script>
import "../vee-validate";
export default {
	props: ["loadData", "send", "validForm", "okOnly", "okTitle", "cancelTitle"],
	data: () => ({isLoading: false, inProgress: false, isError: false, errorMessage: ""}),
	methods: {
		async open() {
			this.reset();
			let modal = this.$refs["bv-modal"];
			modal.show();
			this.isLoading = true;
			try {
				await this.loadData();
			}
			catch (e) {
				this.isError = true;
			}
			finally {
				this.isLoading = false;
			}
		},
		afterOpen(event) {
			event.vueTarget.$refs.modal.classList.add("in");
		},

		reset() {
			this.isError = false; this.inProgress = false; this.isLoading = false;
			this.$emit("resetform");
		},
		handleOK(bvModalEvt) {
			this.isError = false;
			bvModalEvt.preventDefault();
			if (this.inProgress || this.isLoading) {
				return;
			}
			this.inProgress = true;

			this.send().then(res => {
				this.inProgress = false;
				if (res == "ok") {
					this.$refs["bv-modal"].hide();
				}
				else {
					this.isError = true;
					if (res) {
						this.errorMessage = res;
					}
				}
			}).catch(res => {
				this.isError = true;
				this.inProgress = false;
			});
		}
	},
	computed: {
		allowClose() {
			return !this.inProgress;
		},
		allowOK() {
			return !!this.validForm && !this.inProgress && !this.isLoading;
		}
	}
};
</script>
